import React, { useEffect } from "react";
import HomePriceRequest from "../components/priceRequest/HomePriceRequest";
import { PriceRequestScreenProps,  } from "app/routes/types";

const PriceRequest = ({navigation, route}: PriceRequestScreenProps) => {
  const resetFilters = route.params?.resetFilters ?? false

  useEffect(() => {
    if (resetFilters) {
      navigation.setParams({ resetFilters: false })
    }
  }, [resetFilters, navigation])
  
  return <HomePriceRequest key={String(resetFilters)} resetFilters={resetFilters}/>}


export default PriceRequest;
